import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { familyDetails, productFamilies } from "@/content/site";
import { PageHero, Section, CtaBand, FeatureCard, CardGrid } from "@/components/NovaKit";

export default function ServiceFamily() {
  const { slug } = useParams();
  const f = familyDetails[slug];
  const family = productFamilies.find((p) => p.key === slug);
  if (!f || !family) return <Navigate to="/services" replace />;

  return (
    <div data-testid={`service-${slug}-page`}>
      <PageHero eyebrow={`Services / ${f.heading}`} heading={f.heading} highlight={f.heading.replace("Hubinall ", "")} intro={f.subtitle} index={"04." + (["setup","office","connect","intelligence"].indexOf(slug) + 1)} />

      <Section eyebrow="Overview" heading="The commercial layer" indexLabel="04.0" bg="panel">
        <p className="text-base md:text-xl leading-[1.6] text-[#0A0E1A]/85 max-w-4xl border-l-4 border-[#4F46E5] pl-6">
          {f.intro}
        </p>
      </Section>

      <Section eyebrow="Modules" heading={`Modules inside ${f.heading}`} highlight={f.heading} indexLabel="04.1">
        <CardGrid cols={2}>
          {family.modules.map((m, i) => (
            <FeatureCard
              key={m.name}
              index={`MODULE · 0${i + 1}`}
              title={m.name}
              body={m.desc}
              featured={i === 0}
            />
          ))}
        </CardGrid>
      </Section>

      <Section eyebrow="Why customers choose this layer" heading="Built for commercial outcomes" highlight="commercial outcomes" indexLabel="04.2" bg="panel">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {f.why.map((w, i) => (
            <div key={w} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-6 md:p-8">
              <div className="mono text-[11px] tracking-[0.22em] uppercase grad-text font-bold mb-3">Reason · 0{i + 1}</div>
              <p className="text-base md:text-lg leading-relaxed text-[#0A0E1A]/85">{w}</p>
            </div>
          ))}
        </div>
      </Section>

      <CtaBand heading={f.finalCta} ctas={f.ctas} />
    </div>
  );
}
